var exports = {
  "pV": "chartList__cnuHX6",
  "wX": "chartListItem__MYA4Ga",
  "gn": "titleContainer__ZafKl7",
};

module.exports = exports;
